package diana.soleil.design.iraniancanadienbazzar.feature.categories

import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

/** Koin bindings for the Categories feature. Aggregated by the app composition root (`:shared`). */
val categoriesModule = module {
    viewModelOf(::CategoriesViewModel)
}
